import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('admin');
const type = createActionType('admin');

export const OPEN_USER_CONFIGURATION_DIALOG = type('OpenUserConfigurationDialog');
export const CLOSE_USER_CONFIGURATION_DIALOG = type('CloseUserConfigurationDialog');
export const OPEN_TRANSFER_OWNERSHIP_DIALOG = type('OpenTransferOwnershipDialog');
export const CLOSE_TRANSFER_OWNERSHIP_DIALOG = type('CloseTransferOwnershipDialog');
export const CREATE_USER = apiType('CreateUser');
export const UPDATE_USER = apiType('UpdateUser');
export const ACTIVATE_USER = apiType('ActivateUser');
export const DEACTIVATE_USER = apiType('DeactivateUser');
export const DELETE_USER = apiType('DeleteUser');

export const CREATE_API_KEY = apiType('CreateApiKey');
export const CLEAR_API_KEY = type('ClearApiKey');
export const LIST_API_KEYS = apiType('ListApiKeys');
export const REVOKE_API_KEY = apiType('RevokeApiKey');

export const LIST_USER_PROJECTS = apiType('ListUserProjects');
export const TRANSFER_PROJECT_OWNERSHIP = apiType('TransferProjectOwnership');
